import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "appPopup",
  templateUrl: "./popup.component.html",
  standalone: false
})
export class PopupComponent implements OnInit {
  constructor() { }
  @Input() entityName!: string;
  @Input() displayStyle: string = "none";
  @Output() popupOutputEvent = new EventEmitter<boolean>();

  ngOnInit() { }

  openPopup() {
    this.displayStyle = "block";
  }

  yes() {
    this.displayStyle = "none";
    this.postAction(true);
  }

  no() {
    this.displayStyle = "none";
    this.postAction(false);
  }

  postAction(value: boolean) {
    this.popupOutputEvent.emit(value);
  }
}
